import { resolveSupportPageUrl } from 'src/Shared/utils/resolveSupportPageUrl';
import { getLocalePrefix } from 'src/Shared/utils/get-locale-prefix';
export var generateFaqUrl = function (product, faqId, absolute) {
    if (!product) {
        return undefined;
    }
    resolveSupportPageUrl(product);
    var localePrefix = getLocalePrefix();
    var basePath = product.supportPageUrl + "/" + product.sku + "/faq/" + faqId;
    var url = localePrefix && !basePath.startsWith(localePrefix)
        ? "" + localePrefix + basePath
        : basePath;
    return absolute ? location.protocol + "//" + location.host + url : url;
};
